import React from 'react';
import styled from '@emotion/styled';
import Responsive from '../../../../../../ui/utils/Responsive';
import { withTranslate } from '../../../../../shared/i18n/translate';
import { Column, ColumnContent, IColumnProps } from './Column';
import { ColumnHeader } from '../../../../overview/ui/list/item/Column';

interface IFlightNumberColumnProps extends IColumnProps {
	codeShareFlightNumber: string;
}

const StyledColumn = styled(Column)`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;

export const FlightNumberColumn = withTranslate<IFlightNumberColumnProps>(
	({ t, codeShareFlightNumber, columns }) => (
		<StyledColumn columns={columns}>
			<ColumnHeader>{t('web_flight_details_flight')}</ColumnHeader>
			<ColumnContent>{codeShareFlightNumber}</ColumnContent>
		</StyledColumn>
	),
);
